"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ConnectionAlreadyRevokedError extends client_library_1.ExtendableError {
    constructor() {
        super('Connection has already been revoked');
    }
}
exports.default = ConnectionAlreadyRevokedError;
//# sourceMappingURL=ConnectionAlreadyRevokedError.js.map